export const ENTER = 13;
export const TAB = 9;
export const ESCAPE = 27;
export const SPACE = 32;
export const UP_ARROW = 38;
export const DOWN_ARROW = 40;
export const BACKSPACE = 8;
export const DELETE = 46;
